export const pStateToReduxAccountContact = (state) => {
  state = { ...state }

  return state
}
